import React from 'react';
import { displayName } from '../../../App';
import MainGuidanceLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/BatchDownload';

function BatchDownload() {
  document.title = `${displayName}: Batch Download`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default BatchDownload;
